import { Controller } from "@hotwired/stimulus"

// Keeps a form's in-progress edits when Turbo morphs the page after some other change (for
// example a status switch elsewhere on the page). Saving the form clears the guard.
// Connects to data-controller="unsaved-changes"
export default class extends Controller {
  connect() {
    this.dirty = false
  }

  mark() {
    this.dirty = true
  }

  clear() {
    this.dirty = false
  }

  keep(event) {
    if (this.dirty && event.target === this.element) event.preventDefault()
  }
}
